export default "__VITE_ASSET__xAUS4CLk__"